import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Differentiators from './components/Differentiators';
import Capabilities from './components/Capabilities';
import EngagementModels from './components/EngagementModels';
import CTA from './components/CTA';
import Footer from './components/Footer';
import ChatBot from './components/ChatBot';

/**
 * LanceSoft VLSI Subsite - Enhanced with Smartsocs-inspired design
 * 
 * Page Structure:
 * 1. Hero - Value proposition with stats
 * 2. Differentiators - Key strengths grid
 * 3. Capabilities - VLSI services with interactive details
 * 4. Engagement Models - Partnership options
 * 5. CTA - Contact section
 * 6. Footer - Links and ecosystem
 */

function App() {
    return (
        <div className="min-h-screen bg-[#0a1628] text-white selection:bg-[#55C3BD] selection:text-[#0a1628]">
            <Navbar />

            <main>
                <Hero />
                <Differentiators />
                <Capabilities />
                <EngagementModels />
                <CTA />
            </main>

            <Footer />
            <ChatBot />
        </div>
    );
}

export default App;

